const chargePointHasPool = (chargePoint: { poolId?: string | null }): boolean =>
    chargePoint.poolId !== '00000000-0000-0000-0000-000000000000' &&
    chargePoint.poolId !== undefined &&
    chargePoint.poolId !== null

export default chargePointHasPool
